export const centralEquipmentsConstants = {
    FETCH_INSTRUMENTS_DATA_REQUESTING: "FETCH_INSTRUMENTS_DATA_REQUESTING",
    CENTRAL_INSTRUMENTS_DATA_FETCHED: "CENTRAL_INSTRUMENTS_DATA_FETCHED",
    INSTRUMENTS_DATA_FAILED: "INSTRUMENTS_DATA_FAILED",
  };
  